// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const ta: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'எப்படி விளையாடுவது',
  'howto.pieces.heading': 'துண்டுகள்',
  'howto.pieces.source': 'மூலம்',
  'howto.pieces.mirror': 'கண்ணாடி',
  'howto.pieces.switch': 'சுவிட்ச்',
  'howto.pieces.exit': 'வெளியேற்றம்',
  'howto.pieces.wall': 'சுவர்',
  'howto.controls.heading': 'கட்டுப்பாடுகள்',
  'howto.controls.clickSlot.line1': 'இடத்தில் கிளிக் செய்',
  'howto.controls.clickSlot.line2': 'கண்ணாடி வை',
  'howto.controls.dragMirror.line1': 'கண்ணாடியை இழு',
  'howto.controls.dragMirror.line2': 'சுழற்று',
  'howto.controls.rightClick.line1': 'வலது-கிளிக்',
  'howto.controls.rightClick.line2': 'கண்ணாடியை அகற்று',
  'howto.controls.hint': 'மவுஸ் சக்கரம்: 1° நுட்பமான சுழற்சி.   கண்ணாடியைத் தட்டு: 15° சுழற்சி.',
  'howto.objective.line1': 'ஒவ்வொரு சுவிட்சையும் ஒளிரச் செய் — வெளியேற்றத்தின் பூட்டு திறக்கும்.',
  'howto.objective.line2':
    'பின்னர் வெளியேற்றத்தில் கிளிக் செய். முடிந்தவரை குறைந்த கண்ணாடிகளில் தீர்.',

  'howtoColor.title': 'வண்ணம் மற்றும் முப்பட்டகங்கள்',
  'howtoColor.pieces.heading': 'புதிய துண்டுகள்',
  'howtoColor.pieces.prism': 'முப்பட்டகம்',
  'howtoColor.pieces.redSwitch': 'சிவப்பு சுவிட்ச்',
  'howtoColor.pieces.yellowSwitch': 'மஞ்சள் சுவிட்ச்',
  'howtoColor.pieces.whiteSwitch': 'வெள்ளை சுவிட்ச்',
  'howtoColor.how.heading': 'அவை எப்படி வேலை செய்கின்றன',
  'howtoColor.how.line1':
    'ஒரு வெள்ளைக் கதிர் சிவப்பு, பச்சை, நீலம் என மூன்றையும் ஒன்றாக சுமக்கிறது.',
  'howtoColor.how.line2':
    'முப்பட்டகம் வெள்ளை ஒளியை அதன் மூன்று பக்கங்களிலும் மூன்று வண்ணக் கதிர்களாகப் பிரிக்கிறது.',
  'howtoColor.how.line3':
    'வைக்கப்பட்ட முப்பட்டகத்தில் கிளிக் செய்து அதன் உள்ளீட்டு முகத்தை சுழற்று.',
  'howtoColor.switches.line1':
    'சுவிட்ச்கள் வண்ண புள்ளிகளைக் காட்டுகின்றன — அதுதான் அவை விரும்பும் வண்ணம்.',
  'howtoColor.switches.line2':
    'மஞ்சள் சுவிட்சுக்கு (சிவப்பு + பச்சை புள்ளிகள்) இரு வண்ணங்களும் ஒன்றாக வரவேண்டும்.',
  'howtoColor.switches.line3':
    'வெள்ளை சுவிட்சுக்கு (மூன்று வண்ணம்) சிவப்பு, பச்சை, நீலம் ஒன்றாக வரவேண்டும்.',

  'options.hints.label': 'புதிர்களில் குறிப்பு கோணங்களைக் காட்டு',
  'options.hints.help':
    'ஒவ்வொரு பிரதிபலிப்பிலும் வரும் கதிருக்கும் பிரதிபலிக்கும் கதிருக்கும் இடையிலான கோணத்தைக் காட்டுகிறது.',

  'level.01-intro.title': 'வணக்கம் ஒளி',
  'level.02-two-mirrors.title': 'இரண்டு திருப்பங்கள்',
  'level.03-corner.title': 'வழியில் சுவர்',
  'level.04-two-targets.title': 'இரண்டு இலக்குகள்',
  'level.05-tight.title': 'நெருக்கம்',
  'level.06-hello-color.title': 'வணக்கம் வண்ணம்',
  'level.07-pick-a-side.title': 'ஒரு பக்கத்தைத் தேர்',
  'level.08-yellow.title': 'மஞ்சள்',
  'level.09-magenta.title': 'மெஜெண்டா',
  'level.10-spectrum.title': 'நிறமாலை',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'செங்கோணம்',
  'puzzle.hint.angleType.acute': 'குறுங்கோணம்',
  'puzzle.hint.angleType.obtuse': 'விரிகோணம்',
  'puzzle.hint.label': '{angle}°\n{type}',
};
